import React from "react";

const SubscriptionIcon = ({
  size = 24, 
  color = "currentColor",
  strokeWidth = 1.5 
}) => {
  return (
    <svg
      width={size} 
      height={size} 
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 4V20H6V8.8L10.8 4H18ZM18 2H10L4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM9.5 19H7.5V17H9.5V19ZM16.5 19H14.5V17H16.5V19ZM9.5 15H7.5V11H9.5V15ZM13 19H11V15H13V19ZM13 13H11V11H13V13ZM16.5 15H14.5V11H16.5V15Z"
        fill={color}
      />
    </svg>
  );
};

export default SubscriptionIcon;
